import { Stack } from "@mui/material";
import { useContext } from "react";

import Context from "../../context";
import BackgroundImage from "../../DemoLink/components/BackgroundImage";
import LogoHeader from "../../DemoLink/components/LogoHeader";
import DemoTitle from "./DemoTitle";
import PositionsResult from "./PositionsResult.tsx/PositionsResult";

// ----------------------------------------------------------------------

export const ResultsStep = () => {
	const { type } = useContext(Context);
	return (
		<Stack sx={{ width: "auto" }}>
			<BackgroundImage />
			<LogoHeader hideLanguage />
			<DemoTitle />
			{type === "ACTIVE_POSITIONS" && <PositionsResult />}
		</Stack>
	);
};

export default ResultsStep;
